import {
  IsEmail,
  IsNotEmpty,
  MaxLength,
  MinLength,
  ValidateIf,
} from 'class-validator';

import { t } from '@app-velocity/i18n';

export class GuestReviewDto {
  @ValidateIf((e) => !e.name)
  @IsNotEmpty({
    message: t('prototypes:validation.provide_email_or_name'),
  })
  @IsEmail(
    {},
    {
      message: t('users:validation.email_is_not_valid'),
    }
  )
  @MaxLength(64, {
    message: t('prototypes:validation.email_too_long', {
      maxLength: 64,
    }),
  })
  email = '';

  @ValidateIf((e) => !e.email)
  @IsNotEmpty({
    message: t('prototypes:validation.provide_email_or_name'),
  })
  @MinLength(3, {
    message: t('prototypes:validation.user_name_too_short', {
      minLength: 3,
    }),
  })
  @MaxLength(64, {
    message: t('prototypes:validation.user_name_too_long', {
      maxLength: 64,
    }),
  })
  name = '';

  passcode = '';
}
